// Chrome on Android (and Edge, Samsung Internet, Opera) offers to install the site with a "beforeinstallprompt"
// event, which can fire on any page, before the chat opens. It's kept here so the chat's "Install app" can open
// the phone's own install dialog later.
import { currentInvite } from './pushInvite';

let installEvent = null;
const listeners = new Set();

const changed = () => listeners.forEach((listener) => listener());

export const startInstallPromptCapture = () => {
  window.addEventListener('beforeinstallprompt', (event) => {
    // Chrome's own install bar is kept for members the chat won't offer install to (notifications already on or
    // blocked, "Not now" this week). Otherwise the chat is the one place install is offered, as decided: the bar
    // doesn't show on other pages, and an event held when "Not now" is tapped isn't given back to Chrome.
    if (currentInvite({ installEventAvailable: true }) !== 'install') return;
    event.preventDefault();
    installEvent = event;
    changed();
  });
  window.addEventListener('appinstalled', () => {
    installEvent = null;
    changed();
  });
};

export const installAvailable = () => !!installEvent;

// Calls listener whenever install becomes available or not; returns the unsubscribe.
export const subscribeInstallPrompt = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// Opens the phone's install dialog. An event can only be used once, accepted or not, so it's forgotten as soon as
// the member answers.
export const promptInstall = () => {
  const event = installEvent;
  if (!event) return Promise.resolve();
  installEvent = null;
  return Promise.resolve()
    .then(() => event.prompt())
    .then(() => event.userChoice)
    .catch(() => {})
    .then(changed);
};
